import { RegionShared } from "@1games-ru/region-shared";
import { useCallback, useState } from "react";
import TfaMpProvider from "@/core/data-provider/data-mp/tfa/tfa-mp-provider";
import useErrorTranslation from "@/core/helpers/useErrorTranslation";
import { RpcMpProviderSuccessResponse } from "@/core/rpc-mp-provider/responses/rpc-mp-provider-success-response";

export default function useResetPasswordSmsCode() {
  const tError = useErrorTranslation();
  const [sendIsPending, setSendIsPending] = useState(false);
  const [checkIsPending, setCheckIsPending] = useState(false);

  const [sendError, setSendError] = useState<string>("");
  const [checkError, setCheckError] = useState<string>("");

  const [sendIsCompleted, setSendIsCompleted] = useState<null | boolean>(null);
  const [checkIsCompleted, setCheckIsCompleted] = useState<null | boolean>(null);

  const sendCodeHandler = useCallback(
    async (phoneNumber: string) => {
      try {
        if (!phoneNumber) return;
        if (sendIsPending) return;
        setSendIsPending(true);
        setSendError("");

        const response = await TfaMpProvider.sendSmsCode(
          phoneNumber,
          RegionShared.Backend.Events.Auth.RecoverySmsSend,
        );

        if (response instanceof RpcMpProviderSuccessResponse) {
          setSendIsCompleted(true);
        } else {
          setSendError(tError(response.message));
          setSendIsCompleted(false);
        }
      } catch ({ message }) {
        setSendError(tError(message));
        setSendIsCompleted(false);
      } finally {
        setSendIsPending(false);
      }
    },
    [sendIsPending],
  );

  const checkCodeHandler = useCallback(
    async (code: string) => {
      try {
        if (!code) return;
        if (checkIsPending) return;

        setCheckIsPending(true);
        setCheckError("");

        const response = await TfaMpProvider.checkSmsCode(
          code,
          RegionShared.Backend.Events.Auth.RecoverySmsCheck,
        );

        if (response instanceof RpcMpProviderSuccessResponse) {
          setCheckIsCompleted(true);
        } else {
          setCheckError(tError(response.message));
          setCheckIsCompleted(false);
        }
      } catch ({ message }) {
        setCheckError(tError(message));
        setCheckIsCompleted(false);
      } finally {
        setCheckIsPending(false);
      }
    },
    [checkIsPending],
  );

  return {
    sendCodeHandler,
    sendError,
    sendIsPending,
    checkCodeHandler,
    checkError,
    checkIsPending,
    sendIsCompleted,
    checkIsCompleted,
    setSendIsCompleted,
    setCheckIsCompleted,
  };
}
